module.exports = __webpack_public_path__ + "static/media/step3.93606cd7.png";